import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { DirectService } from '@app/modules/direct/services/direct.service';
import { DirectSite } from '@app/shared/interfaces';

@Component({
  selector: 'sbnb-dialog-publish-site',
  templateUrl: './dialog-publish-site.component.html',
})
export class DialogPublishSiteComponent {
  publishing = false;

  constructor(
    public dialogRef: MatDialogRef<DialogPublishSiteComponent>,
    @Inject(MAT_DIALOG_DATA) public site: DirectSite,
    private directService: DirectService
  ) {}

  publish() {
    this.publishing = true;
    this.directService.publishSite(this.site.id).subscribe(
      () => {
        this.dialogRef.close(true);
      },
      () => {
        this.publishing = false;
      }
    );
  }
}
